import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import {
  MultipleOptionsMessageType,
  SettingsMultipleOptionsMessage,
} from '../multiple-options-message/multiple-options-message-type';

@Injectable({
  providedIn: 'root',
})
export class HeaderMultipleOptionsMessageService {
  private isActive = new BehaviorSubject<boolean>(false);
  public isActive$ = this.isActive.asObservable();
  public message?: string;
  public priority?: boolean;
  public onActionSource = new BehaviorSubject<number>(0);
  private onAction = this.onActionSource.asObservable();
  public multipleOptions?: SettingsMultipleOptionsMessage[]; //[{text:'OKAY', color:''}]
  public optionMessageType?: MultipleOptionsMessageType;

  public pushStaticMessage(
    message: string,
    optionMessageType: MultipleOptionsMessageType,
    multipleOptions?: SettingsMultipleOptionsMessage[],
    priority?: boolean,
  ): Observable<number> {
    if (!this.priority) {
      this.message = message;
      this.optionMessageType = optionMessageType;
      this.multipleOptions = multipleOptions ? multipleOptions : [];
      this.priority = priority;
      this.isActive.next(true);
    }
    return this.onAction;
  }

  public pushTemporaryMessage(
    message: string,
    optionMessageType: MultipleOptionsMessageType,
    durationInSeconds = 5,
    multipleOptions?: SettingsMultipleOptionsMessage[],
  ): Observable<number> {
    if (!this.priority) {
      this.message = message;
      this.optionMessageType = optionMessageType;
      this.multipleOptions = multipleOptions ? multipleOptions : [];
      this.isActive.next(true);
      setTimeout(() => {
        this.message = '';
        this.optionMessageType = MultipleOptionsMessageType.NONE;
        this.multipleOptions = [];
        this.isActive.next(false);
      }, 1000 * durationInSeconds);
    }
    return this.onAction;
  }

  public removeMessage(): void {
    this.priority = false;
    this.message = '';
    this.multipleOptions = [];
    this.optionMessageType = MultipleOptionsMessageType.NONE;
    this.isActive.next(false);

    this.onActionSource = new BehaviorSubject<number>(0);
    this.onAction = this.onActionSource.asObservable();
  }
}
